module.exports = __webpack_public_path__ + "img/A58A2308_min.782adb95.jpg";